/**
 * Created by Arif Topcu in 2019
 */
import ComplicationMiniSelector from "./ComplicationMiniSelector";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(ComplicationMiniSelector);
